class ApiUrlConfig {
  _endPoint;

  _apiPath;

  constructor() {
    this._apiPath = '/api/admin/v1';

    switch (process.env.REACT_APP_ENV) {
      case 'development':
        this._endPoint = 'http://localhost:3000';
        // this._endPoint = 'https://dev-api.mysoono.com';
        break;
      case 'qa1':
        this._endPoint = 'https://qa1-api.mysoono.com';
        break;
      case 'qa2':
        this._endPoint = 'https://qa2-api.mysoono.com';
        break;
      case 'qa3':
        this._endPoint = 'https://qa3-api.mysoono.com';
        break;
      case 'staging':
        this._endPoint = 'https://dev-api.mysoono.com';
        break;
      case 'production':
        this._endPoint = 'https://api.mysoono.com';
        break;
      default:
        this._endPoint = 'https://soono-dev-api.herokuapp.com';
        break;
    }
  }

  endPoint() {
    return this._endPoint;
  }

  apiPath() {
    return this._apiPath;
  }

  apiEndPoint() {
    return this.endPoint() + this.apiPath();
  }
}

const apiUrlConfig = new ApiUrlConfig();
export default apiUrlConfig;



// WEBPACK FOOTER //
// ./src/configs/apiUrlConfig.js